import { LuChevronRight, LuLogIn, LuUser } from "react-icons/lu";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../lib/auth";

export const CabinetHeader = ({ container = false }: { container?: boolean }) => {
  const { pathname, search } = useLocation();
  const { user, loading } = useAuth();
  const isAuthRoute = pathname === "/login" || pathname === "/signup";

  const authCtaPath =
    pathname === "/login" ? "/signup" : "/login";
  const authCta =
    pathname === "/login"
      ? { to: `${authCtaPath}${search}`, label: "Зареєструватися", icon: LuUser }
      : { to: `${authCtaPath}${search}`, label: "Увійти", icon: LuLogIn };

  return (
    <header className="bg-black sticky top-0 z-10">
      <div
        className={`h-[74px] flex items-center justify-between gap-6 pl-5 pr-5 md:pr-8 ${
          container ? "mx-auto max-w-cabinet" : "w-full"
        }`}
      >
        <div className="flex items-center gap-10">
          <a href="/" aria-label="IDM" className="shrink-0">
            <img className="size-11" src="/logo.png" alt="IDM" />
          </a>
          <nav className="items-center gap-8 hidden sm:flex">
            <a
              href="https://idm.ua/about-idm"
              className="py-6 font-semibold text-white"
            >
              Про IDM
            </a>
            <a
              href="https://idm.ua"
              className="border-b-2 border-transparent py-6 font-semibold text-white transition hover:text-brand"
            >
              Основний сайт
            </a>
          </nav>
        </div>
        {isAuthRoute ? (
          <Link to={authCta.to} className="btn-brand px-5 py-3 text-sm">
            <authCta.icon className="text-lg" aria-hidden />
            {authCta.label}
          </Link>
        ) : !loading ? (user ? (
          <Link
            to="/dashboard"
            className="inline-flex items-center gap-2.5 rounded border border-line px-3.5 py-3 text-sm font-semibold text-white transition hover:border-neutral-500"
          >
            <LuUser className="text-lg" aria-hidden />
            Кабінет партнера
            <LuChevronRight className="text-lg" aria-hidden />
          </Link>
        ) : (
          <Link to="/login" className="btn-brand px-5 py-3 text-sm">
            <LuLogIn className="text-lg" aria-hidden />
            Увійти
          </Link>
        )) : null}
      </div>
    </header>
  );
};
